import React from 'react';
import { MyButton } from './MyButton.js';
import { useNavigate } from "react-router-dom";

const Hero = ({
    img,
    children,
    background = "var(--primary-gradient-10)",
    className = "py-5",
    buttonText = "Contact Us"
}) => {
    const navigate = useNavigate();

    return (
        <div
            style={{ padding: "0 5%", background: background }}
            className={`mt-1 row g-2 justify-content-between ${className}`}
        >
            <div className="col-12 col-md-5 align-content-center">
                {children}

                <MyButton
                    btntext={buttonText}
                    onClick={() => navigate("/contact")}
                />
            </div>

            <div
                style={{ height: "auto" }}
                className="col-12 col-md-7"
            >
                <img
                    style={{ objectFit: "contain", width: "100%" }}
                    src={img}
                    alt="hero_image"
                />
            </div>
        </div>
    );
};

export default Hero;
